/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { Control, Controller, ControllerProps, FieldError, useController } from "react-hook-form"
import PhoneInput from 'react-phone-number-input'
import 'react-phone-input-2/lib/style.css'
import { FormControl, FormHelperText, TextField, TextFieldProps } from "@mui/material";
import { DefaultFormValues } from "react-phone-number-input/react-hook-form";
import TelephoneCustomComponentRef from "./TelephoneCustomComponentRef";

export type TextFieldElementProps = Omit<TextFieldProps,
  'name'> & {
    validation?: ControllerProps['rules']
    name: string
    parseError?: (error: FieldError) => string
    control: Control<DefaultFormValues, any>
    label?: string
  }

export default function TelephoneInput({
  validation = {},
  parseError,
  type,
  required,
  name,
  control,
  helperText,
  fullWidth,
  sx,
  label,
  ...rest
}: TextFieldElementProps): JSX.Element {

  let { field: { value, onChange }, fieldState: { error } } = useController({
    name: name,
    // rules: attributeInputCallback.isRequired() ? { required: 'This field is required' } : undefined,
    control: control
  })


  if (required) {
    validation.required = `This field is required`
  }




  return (
    <Controller
      name={name}
      control={control}
      rules={validation}
      render={({ field: { value, onChange, onBlur }, fieldState: { invalid,isDirty,isTouched, error } }) =>
        <>
          <FormControl  id={name+'_formControl'} error={!!error} fullWidth>
            <PhoneInput
              placeholder={required ? label+' *' : label}
              name={name}
              value={value}
              onChange={(ev) => {
                onChange(ev)
                if (typeof rest.onChange === 'function') {
                  //rest.onChange(ev)
                }
              }}
              error={error}
              defaultCountry={'US'}
              inputComponent={TelephoneCustomComponentRef}
              disabled={rest.disabled}
              limitMaxLength={true}              
               />
            {!!error && <FormHelperText>{error?.message}</FormHelperText>}
          </FormControl>
        </>
      }
    />


  )
}